import moment from "moment-timezone";
import { BOOKING_TYPE } from "../../../../constants";
import { getBookingDisplayText, getBookingCategory } from "../../../../components/shared/helpFunctions";
import { IconStatus } from "../../../../constants";
import { EventData } from "../types";

export const getBookingIcon = (type: string, eventData?: EventData): string => {
  const displayText = getBookingDisplayText({
    type,
    assistanceDeclaration: (eventData as Record<string, unknown>)?.assistanceDeclaration,
  });

  const iconFromDisplayText = IconStatus.find((item) => item.text === displayText)?.icon;
  if (iconFromDisplayText) { return iconFromDisplayText; }

  const category = getBookingCategory(type);
  const iconFromCategory = IconStatus.find((item) => item.text === category)?.icon;
  if (iconFromCategory) { return iconFromCategory; }

  const defaultIcons: Record<string, string> = {
    [BOOKING_TYPE.BOOKED]: "schedule_on",
    [BOOKING_TYPE.RESERVED]: "order_approval",
    [BOOKING_TYPE.MAINTENANCE]: "test_result",
    [BOOKING_TYPE.AVAILABLE]: "confirm",
  };

  return defaultIcons[type] || "confirm";
};

export const formatTimeRange = (start: string | Date | undefined, end: string | Date | undefined, timezone: string): string => {
  if (!start || !end) { return ""; }
  const startTime = moment(start).tz(timezone).format("h:mm A");
  const endTime = moment(end).tz(timezone).format("h:mm A");
  return `${startTime} - ${endTime}`;
};
